import sanitizeHtml from "sanitize-html";

const ALLOWED_TAGS = ["p", "br", "strong", "b", "em", "i", "ul", "ol", "li"];

export function isEmptyRichTextHtml(value?: string | null) {
  const input = String(value ?? "").trim();
  if (!input) return true;
  return /^<p>(?:<br\s*\/?>|\s|&nbsp;)*<\/p>$/i.test(input);
}

export function sanitizeRichTextHtml(value?: string | null) {
  const input = String(value ?? "").trim();
  if (isEmptyRichTextHtml(input)) return "—";

  const sanitized = sanitizeHtml(input, {
    allowedTags: ALLOWED_TAGS,
    allowedAttributes: {},
    disallowedTagsMode: "discard",
    enforceHtmlBoundary: true,
  });

  return isEmptyRichTextHtml(sanitized) ? "—" : sanitized;
}
